<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "School Drivers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "School Drivers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
        },
        {
          key: "phone1",
          label: "Phone 1",
          sortable: true,
        },
        {
          key: "phone2",
          label: "Phone 2",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "nin",
          label: "NIN",
          sortable: true,
        },
        {
          key: "nxtkin",
          label: "Next of Kin",
          sortable: true,
        },
        {
          key: "nxtkincont",
          label: "Next of Kin Contact",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        address: "",
        phone1: "",
        phone2: "",
        email: "",
        nin: "",
        next_of_kin: "",
        next_of_kin_contact: "",
      },
      deletePos: {
        name: "",
        id: "",
      },
      editPos: {
        name: "",
        address: "",
        phone1: "",
        phone2: "",
        email: "",
        nin: "",
        next_of_kin: "",
        next_of_kin_contact: "",
        id: "",
      },
      existingname: [],
      nameError: "",
      phone1Error: "",
      modal: "",
    };
  },
  watch: {
      SaveStatus(newValue){
          if(newValue){
              this.resetAddModal();
              this.closeModal(this.modal);
          }
      },
  },
  computed: {
    ...mapGetters("transport", ["Drivers", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Drivers.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Drivers.length;
  },
  methods: {
    ...mapActions({
      FetchDrivers: "transport/fetchDrivers",
      AddDriver: "transport/addDriver",
      EditDriver: "transport/editDriver",
      DeleteDriver: "transport/deleteDriver",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Drivers.length;
      this.currentPage = 1;
    },
    resetError() {
      this.nameError = "";
      this.phone1Error = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.phone1 = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingname = this.Drivers.filter((ditance) => {
          return ditance.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingname.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingname = [];
      }
    },
    addDriver(modal) {
      if (this.data.name == "") {
        this.nameError = "Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.phone1 == "") {
        this.phone1Error = "phone1 charged can't be empty";
        return;
      } else {
        this.phone1Error = "";
      }
      if (this.existingname.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddDriver(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editPos.id = values.item.id;
      this.editPos.name = values.item.name;
      this.editPos.phone1 = values.item.phone1;
      this.editPos.phone2 = values.item.phone2;
      this.editPos.email = values.item.email;
      this.editPos.address = values.item.address;
      this.editPos.next_of_kin = values.item.nxtkin;
      this.editPos.next_of_kin_contact = values.item.nxtkincont;
      this.editPos.nin = values.item.nin;
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.name = values.item.name;
    },
    deleteDriver(modal) {
      this.modal = modal;
      this.DeleteDriver(this.deletePos);
      this.closeModal(modal);
    },
    editDriver(modal) {
      if (this.editPos.name == "") {
        this.nameError = "name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editPos.phone1 == "") {
        this.phone1Error = "phone1 field can't be empty";
        return;
      } else {
        this.phone1Error = "";
      }
      this.modal = modal;
      this.EditDriver(this.editPos);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchDrivers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_position')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of School Drivers</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_position')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Drivers"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_position')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal size="lg"
        id="add-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_position')
          )
        "
      >
        <template #modal-title> Add New Driver </template>
        <div class="row">
          <div class="col-md-6">
        <div class="form-group mb-3">
          <label>Name <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="data.name"
              placeholder="Enter Full Name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number 1 <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError()"
              v-model="data.phone1"
              placeholder="Enter Phone Number 1"
            />
          </div>
          <div class="text-danger" v-if="phone1Error">
            <em>{{ phone1Error }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number 2</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.phone2"
              placeholder="Enter Phone Number 2"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Physical Address</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.address"
              placeholder="Enter where driver comes from"
            />
          </div>
        </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
          <label>NIN Number</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.nin"
              placeholder="Enter NIN Number"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Email Address</label>
          <div class="input-group">
            <input
              type="email"
              class="form-control"
              v-model="data.email"
              placeholder="Enter Email Address"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Next of Kin</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.next_of_kin"
              placeholder="Enter Next of Kin Name"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Next of Kin Contact</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.next_of_kin_contact"
              placeholder="Enter Next of Kin Contact"
            />
          </div>
        </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addDriver('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Edit Driver {{ editPos.name }}</template>
        <div class="row">
          <div class="col-md-6">
        <div class="form-group mb-3">
          <label>Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editPos.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number 1</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError(),editCommas()"
              v-model="editPos.phone1"
            />
          </div>
          <div class="text-danger" v-if="phone1Error">
            <em>{{ phone1Error }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number 2</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError(),editCommas()"
              v-model="editPos.phone2"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Physical Address</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="editPos.address"
            />
          </div>
        </div>
        </div>
          <div class="col-md-6">
        <div class="form-group mb-3">
          <label>NIN Number</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="editPos.nin"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Email Address</label>
          <div class="input-group">
            <input
              type="email"
              class="form-control"
              v-model="editPos.email"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Next of Kin</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="editPos.next_of_kin"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Next of Kin Contact</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="editPos.next_of_kin_contact"
            />
          </div>
        </div>
        </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editDriver('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Driver {{ deletePos.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Driver {{ deletePos.name }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteDriver('delete-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>